import { z } from "zod";
import type { Operation } from "../../types";
import { helpCategoryRowSchema, helpIdParams } from "./_shared";

// Every category write mutates the list collection (no per-id GET in this file).

const list: Operation<
  void,
  { include_archived?: boolean },
  void,
  { categories: z.infer<typeof helpCategoryRowSchema>[] }
> = {
  method: "GET",
  path: () => "/api/help/categories",
  query: z.object({ include_archived: z.coerce.boolean().optional() }).partial(),
  response: z.object({ categories: z.array(helpCategoryRowSchema) }),
};

const create: Operation<
  void,
  void,
  {
    slug: string;
    name: string;
    description?: string | null;
    icon?: string | null;
    sort_key?: string;
  },
  z.infer<typeof helpCategoryRowSchema>
> = {
  method: "POST",
  path: () => "/api/help/categories",
  body: z.object({
    slug: z.string().min(1),
    name: z.string().min(1),
    description: z.string().nullable().optional(),
    icon: z.string().nullable().optional(),
    sort_key: z.string().optional(),
  }),
  response: helpCategoryRowSchema,
  invalidates: [list],
};

const update: Operation<
  { id: number },
  void,
  {
    name?: string;
    description?: string | null;
    icon?: string | null;
    sort_key?: string;
  },
  z.infer<typeof helpCategoryRowSchema>
> = {
  method: "PATCH",
  path: ({ id }) => `/api/help/categories/${id}`,
  params: helpIdParams,
  body: z
    .object({
      name: z.string().min(1).optional(),
      description: z.string().nullable().optional(),
      icon: z.string().nullable().optional(),
      sort_key: z.string().optional(),
    })
    .partial(),
  response: helpCategoryRowSchema,
  invalidates: [list],
};

const archive: Operation<
  { id: number },
  void,
  void,
  z.infer<typeof helpCategoryRowSchema>
> = {
  method: "POST",
  path: ({ id }) => `/api/help/categories/${id}/archive`,
  params: helpIdParams,
  response: helpCategoryRowSchema,
  invalidates: [list],
};

export const categories = { list, create, update, archive };
